import { Layout } from "antd";
import { APP_VERSION } from "../../../../version";
import "./footer.css";

const { Footer } = Layout;

/** Uygulama alt bandı — ekranın en altında sabit, ince marka imzası. */
export default function AppFooter()
{
    return (
        <Footer className="app-footer">
            <div className="app-footer-inner">
                <div className="app-footer-brand">
                    <img src="/favicon-ris.svg" alt="" className="app-footer-mark" />
                    <span className="app-footer-name">
                        RIS <span className="app-footer-sub">eCloudPACS</span>
                    </span>
                </div>

                <div className="app-footer-meta">
                    <span className="app-footer-copy">
                        © {new Date().getFullYear()} Kuantum Bulut Bilişim ve Yazılım A.Ş.
                    </span>
                    {/* sürüm — derleme günü (yyyyMMdd); API ile aynı yayında aynı damgayı taşır */}
                    <span className="app-footer-version" title={`Sürüm ${APP_VERSION}`}>
                        v{APP_VERSION}
                    </span>
                    {/* şirket sitesi — kurumsal logo (koyu zemin varyantı) + adres */}
                    <a
                        className="app-footer-site"
                        href="https://kuantumbulut.com"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <img src="/kuantum-logo.svg" alt="" className="app-footer-site-mark" />
                        kuantumbulut.com
                    </a>
                </div>
            </div>
        </Footer>
    );
}
